<script>
    import Header from './Header.vue';
    import moment from 'moment';
    import DownloadDialog from './DownloadDialog.vue';
    import TwoFaDialog from './TwoFaDialog.vue';
    import { generateOtp, getCookie } from '@/services/campaignService';

    export default {
        name: 'DefaultReports',
        components: {
            Header,
            DownloadDialog,
            TwoFaDialog,
        },
        data() {
            return {
                showDateRangeFilter: false,
                startDate: null,
                endDate: null,
                showCustomDate: false,
                dateFilterType: 'LAST_1D',
                reportTypes: [
                    {
                        label: "Budget Utilization",
                        info: "This report provides a comprehensive overview of campaign-level budget utilization, ensuring effective delivery.",
                        value: "BUDGET_UTIL_REPORT",
                    },
                    {
                        label: "Optimization Recommendations",
                        info: "This report offers an overview of campaign performance metrics such as impressions, clicks, ROAS, and CTR%, tailored to the delivery right strategy.",
                        value: "OPTIMISATION_REPORT",
                    },
                    {
                        label: "Target value Performance",
                        info: "This report provides a view of the performance of searched keywords.",
                        value: "TARGETING_VALUE_PERF_REPORT",
                    },
                    {
                        label: "SKU Performance",
                        info: "This report provides a view of performance of SKUs.",
                        value: "SKU_PERF_REPORT",
                    }
                ],
                selectedReport: "",
                showOTPDialog: false,
                defaultReportsPayload: null,
                displayEndDate: null,
            }
        },
        computed: {
            showDateType: function() {
                switch (this.dateFilterType) {
                    case 'CUSTOM': {
                        return this.startDate.split('T')[0] + " - " + this.displayEndDate.split('T')[0];
                    };
                    case 'LAST_1D': {
                        return 'Last 1 day';
                    };
                    case 'LAST_7D': {
                        return 'Last 1 week';
                    };
                    case 'LAST_30D': {
                        return 'Last 1 month';
                    };
                    case 'CURRENT_MONTH': {
                        return 'Current month';
                    }
                    default: {
                        return 'Last 1 day';
                    }
                }
            },
            disableFutureDate() {
            return moment().subtract(1, 'days').format('YYYY-MM-DD');
        },
        },
        methods: {
            onBackBtnClick(){
                const role = getCookie('role');
                this.$router.push({
                    path: `${role === 'SUPERADMIN' || role === 'OPS' ? '/admin' : ''}/analytics`,
                })
            },
            onDateRangeClick(){
                this.showDateRangeFilter = !this.showDateRangeFilter;
                this.showCustomDate = false;
            },
            onDateRangeApply(dateFilterType) {
                if(dateFilterType === 'CUSTOM') {
                    this.showCustomDate = true;
                    return
                }
                this.dateFilterType = dateFilterType;
                this.startDate = this.endDate = null;
                this.showDateRangeFilter = false;
            },
            onCustomDateApply() {
                this.dateFilterType = 'CUSTOM';
                this.startDate = this.startDate ? (moment.utc((this.startDate)).format('YYYY-MM-DDTHH:mm:ss.SSSZ')) : null;
                this.displayEndDate = this.endDate ? (moment.utc(this.endDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ')) : null;
                this.endDate = this.endDate ? (moment.utc(this.endDate).add(1, 'day').startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSZ')) : null;
                this.showDateRangeFilter = false;
                this.showCustomDate = false;
            },

            onDownloadReport(){
                this.showOTPDialog = true;
                const payload = {
                    dateFilter: {
                        fromDate: this.startDate,
                        toDate: this.endDate,
                        dateFilterType: this.dateFilterType
                    },
                    reportType: this.selectedReport,
                };
                this.defaultReportsPayload = payload;
            },
            onGenerateOtp(){
                generateOtp()
            },
            onCancelOTP() {
                this.showOTPDialog = false;
            },
        }
    }
</script>

<template>
    <div class="advancedReportsContainer">
        <div class="headerWrapper"> 
            <div class="titleWrapper"> 
                <img @click="onBackBtnClick" class="arrow" src="../assets/backArrow.svg">
                <div class="title"> Default Reports </div>
            </div>
        </div>
        <div class="mainContainer">
            <div class="content">
                <div class="label">Duration</div>
                <div class="dateRangeWrapper"> 
                    <div @click="onDateRangeClick" class="dateRange">{{ showDateType ?? `Select Duration` }}
                        <img class="arrowIcon" src="../assets/arrowIcon.svg" />
                    </div>
                    <div class="dateRangeContainer" v-if="showDateRangeFilter">
                        <div class="dateText" @click="onDateRangeApply('CUSTOM')">Custom</div>
                        <div v-if="showCustomDate" class="applyClass"> 
                            <input class="dateFilter" type="date" style="margin-right: 12px; cursor: pointer;" v-model="startDate" :max="disableFutureDate">
                            <input class="dateFilter" type="date" style="margin-right: 12px; cursor: pointer;" v-model="endDate" :max="disableFutureDate" :min="startDate">
                            <div v-if="this.startDate && this.endDate" class="applyBtn" @click="onCustomDateApply"> Apply </div>
                        </div>
                        <div class="dateText" @click="onDateRangeApply('LAST_1D')">Last 1 day</div>
                        <div class="dateText" @click="onDateRangeApply('LAST_7D')">Last 1 week</div>
                        <div class="dateText" @click="onDateRangeApply('LAST_30D')">Last 1 month</div>
                        <div class="dateText" @click="onDateRangeApply('CURRENT_MONTH')">Current month</div>
                    </div>
                </div>
                <div class="label report">Type of Report</div>
                <div style="display: flex; align-items: center; margin-bottom: 24px;" v-for="reportType in reportTypes" v-bind:key="reportType">
                    <input v-model="selectedReport" :value="reportType.value" type="radio">
                    <label class="reportLabel" >{{reportType.label}}</label>
                    <div class="tooltip">
                        <img src="../assets/info.svg"/>
                        <span class="tooltiptext">{{reportType.info}} </span>
                    </div>
                </div>
                <button class="downloadBtn" :disabled="!selectedReport" @click="onDownloadReport()">
                    Download Report
                </button>
            </div>
        </div>
        <TwoFaDialog
            v-if="showOTPDialog"
            downloadReport
            @cancel="onCancelOTP"
            :defaultReportsPayload="defaultReportsPayload"
        />
    </div>
</template>

<style scoped>
    .advancedReportsContainer{
        width: 100%;
        background: #F8F8F8;
        font-family: 'Inter-Regular';
    }
    .titleWrapper {
        display: flex;
        align-items: center;
        max-width: 300px;
    }
    .arrow {
        margin-right: 15px;
        width: 18px;
        height: 14px;
        cursor: pointer;
    }
    .headerWrapper {
        display: flex;
        justify-content: space-between;
        padding: 24px 30px 20px 14px;
        margin-bottom: 22px;
        background: #FFFFFF;

    }
    .title {
        font-family: 'Inter-Regular';
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 140%;
        color: #373737;
    }
    .mainContainer {
        margin: 0 24px 20px;
        background: #FFFFFF;
        padding: 12px;
        border-radius: 4px;
        height: 70vh;
    }
    .content {
        padding-top: 42px;
        padding-left: 32px;
    }
    .label{
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        color: #333333;
        margin-bottom: 16px;
    }
    .dateRangeWrapper{
        position: relative;
    }

    .dateRange {
        font-weight: 400;
        font-size: 12px;
        line-height: 23px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        max-width: 210px;
        padding: 9px 18px 9px 15px;
        color: rgba(#41434C, 0.8);
        border: 1px solid #E0E0E0;
        border-radius: 4px;
        margin-right: 12px;
        cursor: pointer;
    }

    .arrowIcon {
        width: 8px;
        height: 5px;
        margin-left: 48px;
    }

    .dateRangeContainer{
        min-width: 370px;
        position: absolute;
        top: 48px;
        z-index: 1;
        padding: 10px;
        border-radius: 4px;
        background: #FFFFFF;
        box-shadow: 3px 4px 9px rgba(0, 0, 0, 0.12);
    }

    .dateFilter{
        border: 1px solid #E0E0E0;
        border-radius: 4px;
        padding: 8px 16px 8px 10px;
        color: #41434C;
        opacity: 0.8;
        margin-right: 12px;
        cursor: pointer;
    }

    .applyClass{
        display: flex;
        margin-bottom: 10px;
    }

    .applyBtn{
        font-weight: 500;
        font-size: 14px;
        line-height: 23px;
        color: #0004B5;
        opacity: 0.8;
        padding: 8px;
        border: 1px solid #0004B5;
        border-radius: 4px;
        cursor: pointer;
    }

    .dateText{
        font-weight: 400;
        font-size: 12px;
        line-height: 23px;
        color: #41434C;
        opacity: 0.8;
        cursor: pointer;
        margin-bottom: 20px;
    }
    .report {
        margin-top: 42px;
    }
    .downloadBtn {
        width: 227px;
        height: 40px;
        margin-top: 40px;
        font-size: 14px;
        font-weight: 700;
        color: #fff;
        padding: 9.5px 16px 9.5px 16px;
        border-radius: 4px;
        border: 0;
        background-color: #2E31BE;
        cursor: pointer;
    }
    .downloadBtn:disabled {
        opacity: 0.3;
    }
    .reportLabel {
        font-size: 12px;
        font-weight: 400;
        line-height: 22px;
        letter-spacing: 0px;
        margin: 0px 8px 0px 8px;
    }
    .tooltip {
        position: relative;
        display: inline-block;
    }

    .tooltip .tooltiptext {
        visibility: hidden;
        width: 352px;
        max-height: 53px;
        background-color: #383838;
        color: #fff;
        text-align: left;
        border-radius: 6px;
        padding: 5px 16px;
        position: absolute;
        z-index: 1;
        top: -5px;
        left: 110%;
        font-size: 10px;
        font-weight: 500;
        line-height: 12px;
        letter-spacing: 0px;

    }

    .tooltip .tooltiptext::after {
        content: "";
        position: absolute;
        top: 12px;
        right: 100%;
        margin-top: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: transparent #383838 transparent transparent;
    }

    .tooltip:hover .tooltiptext {
        visibility: visible;
    }
</style>
